import { Icon as TablerIcon, IconChevronDown } from '@tabler/icons-react';
import classNames from 'classnames';
import * as Flowbite from 'flowbite-react';
import { ComponentProps } from 'react';
import { DeepPartial } from 'react-hook-form';
import { theme as buttonTheme } from 'shared/Button/theme';
import { getReplaceThemeProps } from 'utils/replaceTheme';

export const theme: DeepPartial<Flowbite.DropdownTheme> = Flowbite.createTheme({
    dropdown: {
        arrowIcon: '',
        content: 'focus:outline-hidden',
        floating: {
            animation: 'transition-opacity',
            arrow: {
                base: '',
                style: {
                    dark: '',
                    light: '',
                    auto: '',
                },
                placement: '',
            },
            base: 'bg-white border border-gray-200 focus:outline-hidden rounded-lg w-fit z-10',
            divider: '',
            header: '',
            hidden: 'invisible opacity-0',
            item: {
                container: 'border-b border-b-gray-200 last-of-type:border-b-0',
                base: 'disabled:bg-transparent disabled:text-disabled focus:bg-gray-100 focus:outline-hidden font-medium gap-1.5 hover:bg-gray-100 inline-flex text-wrap items-center px-2.5 py-1.5 text-gray-900 text-left text-sm w-full',
                icon: 'h-3 w-3',
            },
            style: {
                dark: '',
                light: '',
                auto: '',
            },
            target: classNames(
                buttonTheme?.base,
                buttonTheme?.color?.light,
                buttonTheme?.pill,
                buttonTheme?.size?.md,
                'p-0 aria-expanded:bg-gray-900/5 focus:ring-0 [&[aria-expanded="true"]_svg:last-of-type]:rotate-180'
            ),
        },
        inlineWrapper: '',
    },
}).dropdown;

interface DropdownProps extends ComponentProps<typeof Flowbite.Dropdown> {
    icon?: TablerIcon;
}

export const Dropdown = ({
    arrowIcon = true,
    icon: Icon,
    label,
    ...props
}: DropdownProps) => (
    <Flowbite.Dropdown
        arrowIcon={false}
        label={
            <span className="inline-flex items-center font-medium gap-2 text-xs">
                {Icon ? <Icon className="h-3 w-3" /> : null}
                {label}
                {arrowIcon ? (
                    <IconChevronDown aria-hidden="true" className="h-3 w-3" />
                ) : null}
            </span>
        }
        {...getReplaceThemeProps(theme)}
        {...props}
    />
);

Dropdown.displayName = 'Dropdown';

export const { DropdownDivider, DropdownHeader, DropdownItem } = Flowbite;
